/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto
 */
export interface WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto
     */
    groups?: Array<number> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDtoFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto {
    return WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDtoToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceUpdateFamilyMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'groups': value.groups,
    };
}

